import api, { callRefreshToken } from "../config/http-common";

export const generateDaySummarize = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post("/ai/day_summarize", payload);
};

export const getSummaryHistory = async (startTime, endTime) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api
      .securedAxiosApi()
      .get("/ai/summaries?startTime=" + startTime + "&endTime=" + endTime);
};

export const getAllSummaryHistory = async () => {
  const value = await callRefreshToken();
  if (value == true)
  return api
    .securedAxiosApi()
    .get("/ai/history");
};

export const projectPredict = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post("/ai/project_predict", payload);
};

export const getSummaryAttemptCount = async () => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/ai/summary_attempt_count");
};

export const getTimesheetCountBasedOnStartDateAndEndDate = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("timesheet/count/user?startDate=" + payload.startTime + "&endDate=" + payload.endTime);
};
